module.exports = __webpack_public_path__ + "img/admiration.ba8bacf3.svg";